import { DateTime } from '@/utility/luxon';

export function checkIfDateIsOlderThanNowDate(specificDate: string): boolean {
  return DateTime.fromISO(specificDate) < DateTime.now();
}
